package com.essntl.core.unsplash.ui

sealed interface UnsplashEvent {
    data class LoadMorePicture(val query: String) : UnsplashEvent
}